import { useState } from "react";
// import {
//   documentsymbolgreen,
//   greyuploadicon,
//   uploadbigicon,
// } from "../../landingscreen/patientcharts/tabs/Document/svg";
import {
  documentsymbolgreen,
  greyuploadicon,
  uploadbigicon,
} from "../../landingscreen/patientcharts/tabs/Document/svgs";
import { Backdrop, CircularProgress } from "@mui/material";
import dayjs from "dayjs";
import openEmrApi from "../../api/openemrapi";
import ToastMessage from "../../utils/mui/righttoptoast";
import { externalapi } from "../../api/externalapi";
import { searchicongrey } from "../../colorcoding/svg/iconsvg";
import api from "../../api/api";
import {  useRef } from "react";

/* ------------------ CONSTANTS ------------------ */
const DOCUMENT_TYPES = ["Imaging", "Labs", "Clinical", "Encounter"];

const categoryid = {
  Imaging: 32,
  Labs: 2,
  Clinical: 13,
  Encounter: 33,
};

const subviews = {
  Imaging: 1,
  Labs: 0,
  Clinical: 3,
  Encounter: 2,
};

const ALLOWED_TYPES = ["application/pdf", "image/png", "image/jpeg"];
const MAX_FILE_SIZE_MB = 10;

/* ------------------ COMPONENT ------------------ */
const SendToEmrDocument = ({ open, data, setsubview,selectedFax, onClose }) => {
  const [files, setFiles] = useState([]);
  const [selectedType, setSelectedType] = useState("Imaging");
  const [search, setSearch] = useState("");
  const [customType, setCustomType] = useState("");
  const [loading, setLoading] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("success");
  const [openToast, setOpenToast] = useState(false);
const [suggestions, setSuggestions] = useState([]);
const [showSuggestions, setShowSuggestions] = useState(false);
const [selectedSuggestion, setSelectedSuggestion] = useState(null);
  const practiseid = window.getPracticeId();
  const patientid = data?.patientid;
  const apikey = process.env.REACT_APP_OPENEMR_KEY;
const [patientSearch, setPatientSearch] = useState("");
const [documentSearch, setDocumentSearch] = useState("");
const searchTimeoutRef = useRef(null);
const latestSearchRef = useRef("");

  if (!open) return null;

  /* ------------------ HELPERS ------------------ */
  const getTodayDate = () => dayjs().format("YYYY-MM-DD");

  const generateFileName = (category, file) => {
    const timestamp = dayjs().valueOf();
    return `${category}_${timestamp}_${file.name}`;
  };

  const handleToastClose = () => setOpenToast(false);

  const resetForm = () => {
    setFiles([]);
    setSelectedType("");
    setSearch("");
    setCustomType("");
    setToastMessage("");
    setSuggestions([])
    setDocumentSearch('')
    setPatientSearch('')
    setSelectedSuggestion(null)
    setOpenToast(false);
  };
const handleDocumentSearch = (value) => {
  setDocumentSearch(value);

  const match = DOCUMENT_TYPES.find(
    (t) => t.toLowerCase() === value.toLowerCase()
  );

  if (match) setSelectedType(match);
};

  /* ------------------ SEARCH ------------------ */
  const handleSearch1 = (value) => {
    setSearch(value);
    const match = DOCUMENT_TYPES.find(
      (t) => t.toLowerCase() === value.toLowerCase()
    );
    if (match) setSelectedType(match);
  };
const handlePatientSearch = (value) => {
  setPatientSearch(value);
  setSelectedSuggestion(null);
  latestSearchRef.current = value;

  // Clear previous debounce
  if (searchTimeoutRef.current) {
    clearTimeout(searchTimeoutRef.current);
  }

  if (!value.trim()) {
    setSuggestions([]);
    setShowSuggestions(false);
    return;
  }

  // Debounce API call
  searchTimeoutRef.current = setTimeout(async () => {
    try {
      const res = await api.post(
        `/v1/${practiseid}/autocomplete/dssearch`,
        { searchtxt: value }
      );

      // 🚨 Ignore stale responses
      if (latestSearchRef.current !== value) return;

      if (res.status === 200 && Array.isArray(res.data)) {
        setSuggestions(res.data.slice(0, 3));
        setShowSuggestions(true);
      }
    } catch (error) {
      console.error("Search error:", error);
    }
  }, 300); // ✅ 300ms debounce
};


  /* ------------------ FILE HANDLER ------------------ */
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files || []);
    if (!selectedFiles.length) return;

    const validFiles = [];

    for (const file of selectedFiles) {
      if (!ALLOWED_TYPES.includes(file.type)) {
        setToastMessage("Only PDF, PNG, JPG files are allowed");
        setToastSeverity("error");
        setOpenToast(true);
        continue;
      }

     if (file.size > 25 * 1024 * 1024) {
  setToastMessage("Each file must be under 25MB");
  setToastSeverity("error");
  setOpenToast(true);
  continue;
}


      validFiles.push(file);
    }

    setFiles((prev) => [...prev, ...validFiles]);
    e.target.value = "";
  };

  const removeFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index));
  };
const PROXY =
  "/v2/dallas/v1/onboarding-images/proxy?url=";

const withProxy = (url) =>
  url ? `${PROXY}${encodeURIComponent(url)}` : null;

const fetchFaxPdfAsFile = async (faxItem) => {
  const payload = {
    extensionid: faxItem.extensionId,
    attachmentid: faxItem.attachments?.[0]?.id,
    messageid: faxItem.id,
  };

  // 1️⃣ Get document URL
  const res = await externalapi.post(
    "/ringcentral/fax/viewdoc/",
    payload
  );

  if (res.data.result !== "true" || !res.data.documenturl) {
    throw new Error("Fax PDF not available");
  }

  // 2️⃣ Fetch PDF via proxy
  const proxiedUrl = withProxy(res.data.documenturl);

  const pdfRes = await fetch(proxiedUrl);
  if (!pdfRes.ok) {
    throw new Error("Failed to download fax PDF");
  }

  const pdfBlob = await pdfRes.blob();

  // 3️⃣ Convert to File
  return new File(
    [pdfBlob],
    `Fax_${dayjs().format("YYYYMMDD_HHmmss")}.pdf`,
    { type: "application/pdf" }
  );
};






const hasFax = Boolean(selectedFax);

const isUploadDisabled =
  (!files.length && !hasFax) ||
  !selectedType ||
  !selectedSuggestion ||
  loading;



const submit = async () => {
  try {
    setLoading(true);

    const uploadQueue = [];

    // 1️⃣ Local uploaded files
    if (files.length) {
      uploadQueue.push(...files);
    }

    // 2️⃣ Selected fax → fetch PDF → push
  if (selectedFax) {
  const faxFile = await fetchFaxPdfAsFile(selectedFax);
  uploadQueue.push(faxFile);
}


    // 3️⃣ Upload everything in ONE loop
    for (const file of uploadQueue) {
      const formData = new FormData();
      formData.append("apikey", apikey);
      formData.append("pid",selectedSuggestion?.patientid);
      formData.append("file", file);
      formData.append("fname", generateFileName(selectedType, file));
      formData.append("category_id", categoryid[selectedType]);
      formData.append(
        "document_note",
        customType || `${selectedType} document`
      );
      formData.append("docdate", getTodayDate());

      await openEmrApi.post("/documents/create/?emr", formData);
    }

    setToastMessage("Documents uploaded successfully");
    setToastSeverity("success");
    setOpenToast(true);

    setTimeout(() => {
      setLoading(false);
      resetForm();
      onClose();
      setsubview(subviews[selectedType]);
    }, 1200);
  } catch (error) {
    console.error(error);
    setLoading(false);
    setToastMessage("Failed to upload documents");
    setToastSeverity("error");
    setOpenToast(true);
  }
};
const handleSearch = async (value) => {
  setSearch(value);
  setSelectedSuggestion(null);

  if (!value.trim()) {
    setSuggestions([]);
    setShowSuggestions(false);
    return;
  }

  try {
    const res = await api.post(
      `/v1/${practiseid}/autocomplete/dssearch`,
      { searchtxt: value }
    );

    if (res.status === 200 && Array.isArray(res.data)) {
      setSuggestions(res.data.slice(0, 3)); // ✅ max 3
      setShowSuggestions(true);
    }
  } catch (error) {
    console.error("Search error:", error);
  }
};

const handleSuggestionSelect = (item) => {
  setPatientSearch(item.patientinfo || "");
  setSelectedSuggestion(item);
  setShowSuggestions(false);
};

const isUploadAllowed = Boolean(selectedSuggestion);
const isPatientSelected = Boolean(selectedSuggestion);

  /* ------------------ UI ------------------ */
  return (
    <>
      <Backdrop sx={{ color: "#fff", zIndex: 9999 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
<div className="fixed inset-0 z-50 overflow-y-auto bg-black/40">
  <div className="flex min-h-screen items-start justify-center py-10">
    <div className="w-full max-w-md rounded-xl bg-white shadow-lg">

          {/* Header */}
          <div className="flex items-center justify-between border-b px-5 py-4">
            
            <div className="text-lg font-semibold flex items-center gap-2">
              <span>{greyuploadicon}</span>
              Upload Document
            </div>
            <button
              onClick={() => {
                resetForm();
                onClose();
              }}
              className="text-gray-400 hover:text-gray-600"
            >
              ✕
            </button>
          </div>
          <div className="flex justify-center mt-2">

<div className="relative w-full mx-4">
  <div
    className={`flex items-center gap-2 px-4 h-[40px]
      rounded-[19px] border bg-[#F5F6FA]
      ${selectedSuggestion ? "border-blue-500" : "border-[#D5D5D5]"}`}
  >
    <div>{searchicongrey}</div>

  <input
  type="text"
  placeholder="Search Patient"
  value={
    selectedSuggestion?.patientinfo
      ? selectedSuggestion.patientinfo
      : patientSearch
  }
  onChange={(e) => {
    setSelectedSuggestion(null);
    handlePatientSearch(e.target.value);
  }}
  className="flex-1 bg-transparent outline-none text-sm"
/>

  </div>

  {/* Suggestions */}
  {showSuggestions && suggestions.length > 0 &&patientSearch && (
    <div className="absolute z-50 mt-1 w-full rounded-lg border bg-white shadow">
      {suggestions.map((item, index) => (
        <div
          key={index}
          onClick={() => handleSuggestionSelect(item)}
          className="cursor-pointer px-4 py-2 text-sm text-start hover:bg-gray-100"
        >
          {item?.patientinfo}
        </div>
      ))}
    </div>
  )}
</div>


          </div>
{/* {selectedSuggestion?.patientinfo? (
  <div className="mx-4 mt-3 mb-2 rounded-lg border text-start border-[#E5E7EB] bg-[#F9FAFB] px-4 py-2">
    <p className="text-xs text-gray-500">Selected Patient</p>
    <p className="text-sm font-semibold text-gray-800 truncate">
      {selectedSuggestion?.patientinfo}
    </p>
  </div>
) : (
  <div className="mx-4 mt-3 mb-2 rounded-lg border border-red-200 bg-red-50 px-4 py-2">
    <p className="text-xs text-red-500">No patient selected</p>
  </div>
)} */}

          <div className="px-5 py-4">
          
 <label
  className={`flex flex-col items-center justify-center rounded-lg border-[2px] p-6 text-center
    ${isUploadAllowed
      ? "cursor-pointer border-[#E5E7EB]"
      : "cursor-not-allowed border-gray-300 opacity-50"}`}
>
              <input
                type="file"
                multiple
                accept=".pdf,.png,.jpg,.jpeg"
                className="hidden"
                  disabled={!isUploadAllowed} 
                onChange={handleFileChange}
              />

              {!files.length ? (
                <>
                  <div className="mb-2 bg-[#F3F4F6] rounded-full h-12 w-12 flex items-center justify-center">
                    {uploadbigicon}
                  </div>
                  <p className="text-sm font-medium">
                    Click to upload or drag and drop
                  </p>
                  <p className="text-xs text-gray-500">
                    PDF, PNG, JPG up to 25MB
                  </p>
                </>
              ) : (
                <>
                  <div className="mb-2 bg-[#D0FAE5] rounded-full h-10 w-10 flex items-center justify-center">
                    {documentsymbolgreen}
                  </div>
<div className="mt-1 w-full max-h-40 overflow-y-auto pr-1">
  {files.map((file, index) => (
    <div
      key={index}
      className="mb-2 flex items-center justify-between rounded-md border p-2 text-left"
    >
      <div className="truncate">
        <p className="text-sm font-medium truncate">{file.name}</p>
        <p className="text-xs text-gray-500">
          {(file.size / 1024 / 1024).toFixed(2)} MB
        </p>
      </div>

      <button
        type="button"
        onClick={() => removeFile(index)}
        className="ml-2 text-xs text-red-500 hover:underline"
      >
        Remove
      </button>
    </div>
  ))}
</div>

                </>
              )}
            </label>

            {/* Document Type */}
            <p className="mt-4 mb-2 text-sm font-semibold text-start">
              Document Type
            </p>

           <input
  type="text"
  placeholder="Search"
  value={documentSearch}
  onChange={(e) => handleDocumentSearch(e.target.value)}
  className={`w-full mb-3 rounded-full px-4 py-2 text-sm border
    ${!isPatientSelected
      ? "bg-gray-100 cursor-not-allowed"
      : "bg-[#F5F6FA] border-[#D5D5D5]"}`}
/>


            <div className="mb-3 grid grid-cols-2 gap-2">
              {DOCUMENT_TYPES.map((type) => (
                <button
                  key={type}
                   disabled={!isPatientSelected}
                  onClick={() => setSelectedType(type)}
                 className={`rounded-lg border px-3 py-2 text-sm
      ${!isPatientSelected
        ? "bg-gray-100 text-gray-400 cursor-not-allowed"
        : selectedType === type
          ? "bg-blue-50 border-blue-500 text-blue-600"
          : "border-gray-300"}`}
                >
                  {type}
                </button>
              ))}
            </div>

            <input
              type="text"
              placeholder="Specify document type"
              value={customType}
                disabled={!isPatientSelected}
              onChange={(e) => setCustomType(e.target.value)}
           className={`w-full rounded-xl border px-3 py-2 text-sm
    ${!isPatientSelected
      ? "bg-gray-100 cursor-not-allowed"
      : ""}`}
            />
          </div>

          {/* Footer */}
          <div className="flex justify-end gap-3 border-t px-5 py-3">
            <button
              onClick={onClose}
              className="rounded-md border px-4 py-2 text-sm"
            >
              Cancel
            </button>

            <button
              disabled={isUploadDisabled}
              onClick={submit}
              className={`rounded-md px-4 py-2 text-sm text-white ${
                isUploadDisabled
                  ? "bg-gray-300 cursor-not-allowed"
                  : "bg-blue-600 hover:bg-blue-700"
              }`}
            >
              Upload Document
            </button>
          </div>
       
       </div>
        </div>

        <ToastMessage
          message={toastMessage}
          severity={toastSeverity}
          open={openToast}
          handleClose={handleToastClose}
        />
      </div>
    </>
  );
};

export default SendToEmrDocument;
